import { Checkbox as AntdCheckbox } from "antd";
import "./style.scss";

function Checkbox({ children, onChange, isChecked, className }) {
  return (
    <AntdCheckbox
      className={`custom-checkbox ${className ? className : ""}`}
      onChange={onChange}
      checked={isChecked}
    >
      {children}
    </AntdCheckbox>
  );
}

export default Checkbox;
